import { getValue, setValue, isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * Angular Form Base Module
 */
export class FormBase {
    propagateChange(_) { return; }
    propagateTouch() { return; }
    localChange(e) {
        let value = (e.checked === undefined ? e.value : e.checked);
        if (value !== this.ngrValue && this.propagateChange !== undefined && value !== undefined) {
            // Update angular from our control
            this.propagateChange(value);
        }
    }
    registerOnChange(registerFunction) {
        this.propagateChange = registerFunction;
    }
    registerOnTouched(registerFunction) {
        this.propagateTouch = registerFunction;
    }
    twoWaySetter(newVal, prop) {
        let oldVal = getValue(prop, this.properties);
        let ele = this.inputElement || this.element;
        if (oldVal === newVal &&
            (ele.value === undefined || ele.value === '')) {
            return;
        }
        this.saveChanges(prop, newVal, oldVal);
        setValue(prop, (isNullOrUndefined(newVal) ? null : newVal), this.properties);
        getValue(prop + 'Change', this).emit(newVal);
    }
    ngAfterViewInit() {
        // Used setTimeout for template binding
        // Refer Link: https://github.com/angular/angular/issues/6005
        setTimeout(() => {
            /* istanbul ignore else */
            if (typeof window !== 'undefined') {
                this.appendTo(this.element);
                let ele = this.inputElement || this.element;
                ele.addEventListener('focus', this.ngOnFocus.bind(this));
                ele.addEventListener('blur', this.ngOnBlur.bind(this));
            }
        });
    }
    setDisabledState(disabled) {
        this.enabled = !disabled;
    }
    writeValue(value) {
        //update control value from angular
        if (this.checked === undefined) {
            this.value = value;
        }
        else {
            if (typeof value === 'boolean') {
                this.checked = value;
            }
            else {
                this.checked = value === this.value;
            }
        }
        if (value === null) {
            return;
        }
        this.ngrValue = value;
    }
    ngOnFocus(e) {
        /* istanbul ignore else */
        if (this.skipFromEvent !== true) {
            this.focus.emit(e);
        }
    }
    ngOnBlur(e) {
        this.propagateTouch();
        /* istanbul ignore else */
        if (this.skipFromEvent !== true) {
            this.blur.emit(e);
        }
    }
}
